"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("@olxbr/ds-web/lib/styles.css");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _client = require("@apollo/client");
var _styledComponents = require("styled-components");
var _ChatBox = _interopRequireDefault(require("../components/containers/ChatBox"));
var _MessageAdView = _interopRequireDefault(require("../components/containers/MessageAdView"));
var _MessageListing = _interopRequireDefault(require("../components/containers/MessageListing"));
var _Modal = _interopRequireDefault(require("./../components/containers/Modal"));
var _Router = _interopRequireDefault(require("../components/containers/Router"));
var _Route = _interopRequireDefault(require("../components/containers/Route"));
var _store = _interopRequireDefault(require("../store"));
var _actions = require("../actions");
var _olx = _interopRequireDefault(require("../themes/olx"));
var _grupoZap = _interopRequireDefault(require("../themes/grupo-zap"));
var _style = require("./style");
var _exceptions = require("../exceptions");
var _global = require("../helpers/global");
var _DevControlPanel = _interopRequireDefault(require("../components/containers/DevControlPanel"));
var _env = _interopRequireDefault(require("../helpers/env"));
var _init = require("../helpers/apollo/init");
var _platform = require("../helpers/platform");
var _datadog = _interopRequireDefault(require("../helpers/datadog"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var App = /*#__PURE__*/function (_Component) {
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _callSuper(this, App, [props]);
    _defineProperty(_this, "messageAdview", function () {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageAdView["default"], {});
    });
    _defineProperty(_this, "chatBoxWithRenderToRight", function () {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatBox["default"], {
        renderToRight: function renderToRight() {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageListing["default"], {});
        }
      });
    });
    _defineProperty(_this, "chatBox", function () {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatBox["default"], {});
    });
    _defineProperty(_this, "messageListing", function () {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageListing["default"], {});
    });
    _this.store = (0, _store["default"])(props);
    (0, _global.configureGlobalObject)(_this.store);
    _this.client = (0, _init.initApollo)(props);
    return _this;
  }
  _inherits(App, _Component);
  return _createClass(App, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.store.dispatch((0, _actions.updateRenderProps)(this.props));
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      this.store.dispatch((0, _actions.handleError)(new _exceptions.UIException(errorInfo, error)));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      !_platform.isMsite && this.store.dispatch((0, _actions.disconnect)());
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        app = _this$props.app,
        isMsite = _this$props.isMsite;
      (0, _platform.setIsMsite)(isMsite);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_client.ApolloProvider, {
        client: this.client,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRedux.Provider, {
          store: this.store,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.ThemeProvider, {
            theme: app === 'chat-pro-zap' ? _grupoZap["default"] : _olx["default"],
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
              children: [_env["default"].isProduction() || /*#__PURE__*/(0, _jsxRuntime.jsx)(_DevControlPanel["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_datadog["default"], {
                app: app
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Router["default"], {
                children: function children(hasCurrentChat, isMSite, hasListId) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Route["default"], {
                      isShow: hasListId,
                      component: _this2.messageAdview
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Route["default"], {
                      isShow: !hasListId && !isMSite,
                      component: _this2.chatBoxWithRenderToRight
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Route["default"], {
                      isShow: !hasListId && isMSite && !hasCurrentChat,
                      component: _this2.chatBox
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Route["default"], {
                      isShow: !hasListId && isMSite && hasCurrentChat,
                      component: _this2.messageListing
                    })]
                  });
                }
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal["default"], {})]
            })
          })
        })
      });
    }
  }]);
}(_react.Component);
var _default = exports["default"] = App;